<template>
  <div class="contenedor-difusion">
    <!-- <Header2/> -->
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Nivel 1</h1>
        <div class="barra"></div>
      </div>
      <section class="contenedor-login">
        <div class="contenedor-difusion-imagen">
          <img src="@/assets/abhi.png" alt="Abhi Iyengar">
        </div>
        <div class="contenedor-seminario">

          <p>“<i>Cultiven en los alumnos la alegría del proceso de aprendizaje, en vez de llegar a un destino.”</i> <br> — Geeta y Prashant Iyengar</p>

          <p>A partir de la CERTIFICACIÓN NIVEL 1, los profesores y profesoras están habilitadas únicamente para impartir clases generales donde deben demostrar, observar y corregir.</p>
          <h2 class="titulo_beneficios">Clases generales</h2>

          <ul class="lista_precios_seminario">
            <li><span>&#8226;</span> Solo pueden dictar clases generales de 1 hora y 15 minutos, o 1 hora y 30 minutos de duración.</li>
            <li><span>&#8226;</span> Las clases deben ajustarse al silabario correspondiente a su nivel de certificación.</li>
            <li><span>&#8226;</span> No podrán dictar clases terapéuticas.</li>
            <li><span>&#8226;</span> No se permite mezclar otros métodos de enseñanza.</li>
            <li><span>&#8226;</span> Es fundamental respetar la evolución de cada estudiante, adaptándose a sus necesidades sin forzar el aprendizaje.</li>
          </ul>

          <h2 class="titulo_beneficios">Embarazo</h2>

          <ul class="lista_precios_seminario">
            <li><span>&#8226;</span> No podrán dictar clases específicas para embarazadas.</li>
            <li><span>&#8226;</span> Podrán continuar guiando a alumnas regulares que han quedado embarazadas, siempre que se trate de embarazos sin complicaciones.</li>
            <li><span>&#8226;</span> En caso de embarazos con complicaciones, la alumna debe ser derivada a una persona certificada en Nivel III o superior.</li>
            <li><span>&#8226;</span> Si en la región no hubiera nivel III o superior, podrán continuar enseñando solo bajo consulta y supervisión de una persona con dicha certificación.</li>
          </ul>

          <h2 class="titulo_beneficios">Abordaje Terapéutico</h2>

          <ul class="lista_precios_seminario">
            <li><span>&#8226;</span> Pueden atender problemas comunes dentro de sus clases (dolor de cuello, hombros, espalda baja o rodillas).</li>
            <li><span>&#8226;</span> No están habilitadas a ofrecer clases específicas con fines terapéuticos.</li>
            <li><span>&#8226;</span> Si un estudiante requiere atención terapéutica, debe ser derivado a una persona certificada en Nivel III o superior.</li>
            <li><span>&#8226;</span> Si en la región no hubiera nivel III o superior, podrán continuar enseñando solo bajo consulta y supervisión de un profesor con dicha certificación.</li>
          </ul>

          <h2 class="titulo_beneficios">Clases Especiales, talleres o retiros</h2>

          <p>En consonancia con las recomendaciones de Abhijata Iyengar y con el espíritu del Manual de Certificación 2020, la AAYI considera que, en la etapa correspondiente a la certificación de Nivel 1, el desarrollo docente encuentra su principal base en la enseñanza sostenida de clases generales regulares.</p>
          <p>Es en ese espacio de práctica y enseñanza continua donde se profundizan la observación, la capacidad de acompañar procesos de aprendizaje y la maduración pedagógica necesarias para el crecimiento dentro del método. Por ello, valoramos especialmente el acompañamiento de mentores y profesores de mayor nivel en este recorrido formativo.</p>
          <p>Al mismo tiempo, reconociendo las particularidades de nuestro país y la importancia de sostener espacios de estudio y difusión de las enseñanzas de B.K.S. Iyengar, la AAYI considera oportuno establecer algunos lineamientos orientativos respecto de las clases especiales, talleres y retiros, procurando que estos espacios se desarrollen de manera acorde con el espíritu del método y con el momento formativo de cada docente.</p>
          <p>Aquellos profesores que deseen desarrollar estas modalidades deberán cumplir los siguiente requisitos:</p>

          <p>1. Haber dictado clases generales de Nivel I por un mínimo de dos (2) años (24 meses) desde la obtención de su certificación.</p>
          <p>2. Participar regularmente en los encuentros organizados por la AAYI con profesores del RIMYI.</p>
          <p>3. Tomar clases regulares y mantener un vínculo cercano con un mentor/a o profesor/a de mayor nivel. Este acompañamiento no solo ofrece sostén y guía en cada paso, sino que también enriquece la formación continua y fortalece el sentido de comunidad.</p>
          <p>4. Completar el formulario informativo correspondiente a cada actividad, a fin de mantener el registro institucional de la AAYI.</p>

          <h2 class="titulo_beneficios">Sesión de enseñanza dentro de estas modalidades</h2>

          <p>Se considera encuadrada dentro de estas modalidades, toda sesión de enseñanza de la metodología y práctica del Yoga Iyengar® que cumpla con una o más de las siguientes condiciones:</p>

          <ul class="lista_precios_seminario">
            <li><span>&#8226;</span> Supere los 90 minutos de duración.</li>
            <li><span>&#8226;</span> Se dicte fuera del cronograma habitual de clases.</li>
            <li><span>&#8226;</span> Esté dirigido a personas más allá de los alumnos regulares de la sala.</li>
          </ul>

          <p>Estas sesiones deberán ajustarse a las siguientes pautas:</p>

          <ul class="lista_precios_seminario">
            <li><span>&#8226;</span> Tener una duración de 2 horas máximo. </li>
            <li><span>&#8226;</span> Ajustarse al silabario de asanas y pranayamas correspondiente al nivel I. </li>
            <li><span>&#8226;</span> No se podrán abordar temas terapéuticos o vinculados a patologías específicas como por ejemplo “Taller de caderas” , o “Taller de espalda baja”.</li>
            <li><span>&#8226;</span> No podrá hacerse referencia a la profundización de la práctica.</li>
          </ul>

          <p>A modo orientativo, se consideran acordes al Nivel 1 propuestas tales como: </p>

          <ul class="lista_precios_seminario">
            <li><span>&#8226;</span> Uso de elementos en las posturas.</li>
            <li><span>&#8226;</span> Principios de alineación en posturas de pie.</li>
            <li><span>&#8226;</span> Práctica de flexiones hacia adelante.</li>
            <li><span>&#8226;</span> Práctica de extensiones hacia atrás.</li>
            <li><span>&#8226;</span> Práctica de posturas invertidas.</li>
            <li><span>&#8226;</span> Introducción al pranayama.</li>
          </ul>

          <p>La Comisión Directiva y los Comités correspondientes podrán formular observaciones, sugerencias o recomendaciones cuando una actividad proyectada no resulte compatible con el nivel de certificación o con los lineamientos aquí expuestos, con el propósito de preservar la integridad del método , cuidar la claridad en la transmisión y evitar confusiones respecto del alcance de la habilitación docente.</p>

          <p><a
             href="https://forms.gle/UaA3S8dP3Kwci2eF7"
             target="_blank"
             class="link_beneficios"
             >
              LINK AL FORMULARIO
            </a>
          </p>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import store from '../store'
export default {
  name: 'Nivel1Requisitos',
  components: {
  },
  data: function () {
    return {
      store,
      checked: false
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style>

</style>
